import { COMPARE_PRODUCTS_SETTING } from '#shared/lib/const';

export const DELETE_CHARACTERISTICS_ERRORS = {
    DELETE_MAPPING: `Не получится удалить характеристику, которая выбрана для настройки загрузки товаров в «${COMPARE_PRODUCTS_SETTING}»`,
    DELETE_COLLECTION: 'Не получится удалить характеристику, которая участвует в динамической коллекции',
    DELETE_GROUPPING: 'Не получится удалить характеристику, которая участвует в объединении вариантов',
};
